import { convertDateToBrazilFormat } from '@repo/ui';
import { StudentsWorkloadAchievementGroup } from 'domain/models';
import { Badge, Card, CardBody, Collapse } from 'reactstrap';

import { pluralize } from '../helpers';
import { WorkloadAchievementTable } from '../workload-achievement-table';

interface IProps {
  group: StudentsWorkloadAchievementGroup;
  isOpen: boolean;
  onToggle: () => void;
}

export const WorkloadAchievementGroup = ({
  group,
  isOpen,
  onToggle,
}: IProps) => {
  const rows = group.rows || [];

  return (
    <Card className="border shadow-none mb-3">
      <div
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={onToggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggle();
          }
        }}
        className="d-flex align-items-center gap-3 p-3"
      >
        <div className="avatar-sm flex-shrink-0">
          <span className="avatar-title rounded bg-primary-subtle text-primary fs-20">
            <i className="ri-team-line"></i>
          </span>
        </div>

        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <h5 className="mb-1 fs-15">
            {group.groupName || 'Grupo não informado'}
          </h5>

          <div className="d-flex align-items-center flex-wrap gap-2">
            {group.groupCode && (
              <Badge className="bg-primary-subtle text-primary fw-medium">
                {group.groupCode}
              </Badge>
            )}

            <Badge className="bg-body-secondary text-body fw-medium">
              {pluralize(rows.length, 'estudante', 'estudantes')}
            </Badge>

            {(group.startDate || group.endDate) && (
              <span className="d-inline-flex align-items-center gap-1 text-muted fs-13">
                <i className="ri-calendar-2-line"></i>
                {group.startDate
                  ? convertDateToBrazilFormat(group.startDate)
                  : '-'}{' '}
                -{' '}
                {group.endDate ? convertDateToBrazilFormat(group.endDate) : '-'}
              </span>
            )}
          </div>
        </div>

        <i
          className={`fs-22 text-muted flex-shrink-0 ${
            isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
          }`}
        ></i>
      </div>

      <Collapse isOpen={isOpen}>
        <CardBody className="border-top p-0 m-0">
          <WorkloadAchievementTable group={group} />
        </CardBody>
      </Collapse>
    </Card>
  );
};
